export default "__VITE_ASSET__ClQtSdIM__"